var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.249 15.1479C12.4964 15.1479 11.746 14.8993 11.1183 14.402L6.07263 10.334C5.70926 10.0415 5.65301 9.5094 5.94438 9.14715C6.23801 8.78602 6.76901 8.72865 7.13126 9.02002L12.1724 13.0835C12.8058 13.5853 13.6979 13.5853 14.3358 13.079L19.3263 9.02227C19.6885 8.7264 20.2195 8.78265 20.5143 9.1449C20.8079 9.50602 20.7528 10.037 20.3916 10.3318L15.3921 14.3953C14.7599 14.897 14.0039 15.1479 13.249 15.1479Z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 25,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.125 2.25H25.3124V24.1875H1.125V2.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69375 22.5H18.7413C18.7435 22.4977 18.7525 22.5 18.7593 22.5C20.0429 22.5 21.1814 22.041 22.0544 21.1691C23.068 20.16 23.6249 18.7099 23.6249 17.0865V9.36C23.6249 6.21788 21.5706 3.9375 18.7413 3.9375H7.696C4.86663 3.9375 2.81238 6.21788 2.81238 9.36V17.0865C2.81238 18.7099 3.37038 20.16 4.38288 21.1691C5.25588 22.041 6.3955 22.5 7.678 22.5H7.69375ZM7.67463 24.1875C5.93875 24.1875 4.3885 23.5575 3.1915 22.365C1.85838 21.0352 1.12488 19.161 1.12488 17.0865V9.36C1.12488 5.30663 3.94975 2.25 7.696 2.25H18.7413C22.4875 2.25 25.3124 5.30663 25.3124 9.36V17.0865C25.3124 19.161 24.5789 21.0352 23.2458 22.365C22.0499 23.5564 20.4985 24.1875 18.7593 24.1875H18.7413H7.696H7.67463Z",
    fill: "#525252"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.a4d48469256d50b90350b3792b5b9f76.svg";
export { ForwardRef as ReactComponent };